<template>
  <div>
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            交货单号：<span v-if="formData.collectNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.collectNo }}</span>
            <span v-else class="information">待生成</span>

            <!-- 状态 -->
            <span v-if="formData.stat==1" class="information">待发货</span>
            <span v-if="formData.stat==3" class="information">已发货</span>
            <span v-if="formData.stat==99" class="information">取消</span>


          </div>
          <div class="fr">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       @click="showShipmentsDialog=true" v-if="formData.stat==1 && parts_apply_outbound">发货
            </el-button>
          </div>
        </div>

        <div>

          <!-- 基本信息 -->
          <dix style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
            <div class="d-cont edit-mce-box" style="width: 98%;">
              <div class="d-item">
                <div class="title first"><b>主信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      交货数量
                    </th>
                    <td>
                      {{formData.qty}}
                    </td>

                    <th>
                      交货人工号
                    </th>
                    <td>
                      {{formData.collecterWorker}}
                    </td>

                    <th>
                      交货人名称
                    </th>
                    <td>
                      {{formData.collecter}}
                    </td>
                  </tr>

                  <tr>
                    <th>过帐时间</th>
                    <td>{{formData.accountTime}}</td>

                    <th>领料时间</th>
                    <td>{{formData.collectTime}}</td>

                    <th>物流公司名称</th>
                    <td>{{formData.deliverCompanyName}}</td>

                    <th>物流单号</th>
                    <td>{{formData.deliverNo}}</td>
                  </tr>

                  <tr>
                    <th>物流子单号</th>
                    <td>{{formData.deliverNoSub}}</td>

                    <th>总件数</th>
                    <td>{{formData.allQty}}</td>

                    <th>总重量</th>
                    <td>{{formData.allWeight}}</td>

                    <th>总体积</th>
                    <td>{{formData.allVolume}}</td>
                  </tr>

                  <tr>
                    <th>揽收时间</th>
                    <td>{{formData.collectingDate}}</td>

                    <th>预计到达时间</th>
                    <td>{{formData.etaDate}}</td>

                    <th>最新路由信息</th>
                    <td>{{formData.newDeliverInfo}}</td>

                    <th>签收时间</th>
                    <td>{{formData.deliverSignTime}}</td>
                  </tr>

                  <tr>
                    <th>
                      外部交货单号
                    </th>
                    <td>
                      {{formData.send1No}}
                    </td>

                    <th>交货同步状态</th>
                    <td v-if="formData.send1Flag == 1">失败</td>
                    <td v-else-if="formData.send1Flag == 2">已传</td>
                    <td v-else-if="formData.send1Flag == 3">取消</td>
                    <td v-else-if="formData.send1Flag == 0">未传</td>
                    <td v-else>未传</td>

                    <th>交货同步时间</th>
                    <td>{{formData.send1Date}}</td>

                    <th>交货同步备注</th>
                    <td>{{formData.send1Message}}</td>
                  </tr>

                  <tr>
                    <th>外部发货单号</th>
                    <td>{{formData.send2No}}</td>

                    <th>发货同步状态</th>
                    <td v-if="formData.send2Flag == 1">失败</td>
                    <td v-else-if="formData.send2Flag == 2">已传</td>
                    <td v-else-if="formData.send2Flag == 3">取消</td>
                    <td v-else-if="formData.send2Flag == 0">未传</td>
                    <td v-else>未传</td>

                    <th>发货同步时间</th>
                    <td>{{formData.send2Date}}</td>

                    <th>发货同步备注</th>
                    <td>{{formData.send2Message}}</td>
                  </tr>
                  <tr>
<!--                    <th>收货人</th>-->
<!--                    <td>{{formData.deliverMan}}</td>-->

<!--                    <th>收货人电话</th>-->
<!--                    <td>{{formData.deliverMobile}}</td>-->

                    <th>打印次数</th>
                    <td>{{formData.printNum}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                  <div class="title first"><b>申请明细</b></div>
                  <div class="item-button" style="margin-top: 8px;"></div>
                </div>
                <div>
                  <vxe-table
                    style="margin-top: 0px;"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="230"
                    :column-config="{ resizable: true }"
                    @checkbox-change="selectChangeEvent"
                    @checkbox-all="selectChangeEvent"
                    :data="formData.spPartsApplyCollectLineDTOList">
<!--                    <vxe-column type="checkbox" width="40"/>-->
                    <vxe-column field="partsCode" title="配件编码" width="130"></vxe-column>
                    <vxe-column field="partsName" title="配件名称" width="130"></vxe-column>
                    <vxe-column field="lineId" title="行号" width="80"></vxe-column>
                    <vxe-column field="lineId1" title="回传行号" width="80"></vxe-column>
                    <vxe-column field="checkQty" title="交货数量" width="100"></vxe-column>
                    <vxe-column field="qty" title="回传交货数量" width="100"></vxe-column>
<!--                    <vxe-column field="qty" title="交货数量" width="100"></vxe-column>-->
                    <vxe-column field="sitePrice" title="价格" width="100"></vxe-column>
                    <vxe-column field="applyNo" title="申请单号" width="200"></vxe-column>
                  </vxe-table>
                </div>
              </div>
            </div>
          </dix>
        </div>
      </el-form>
    </div>
    <!--发货-->
    <shipments-dialog v-if="showShipmentsDialog"
                      :dataId="dataId"
                      :visiable.sync="showShipmentsDialog"
                      multi="true"
                      @goBackIndex="goBackIndex"
    />
  </div>
</template>

<script>
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
import ShipmentsDialog from "@/views/accessories/applyFor/apply/shipmentsDialog.vue";

export default {
  mixins: [editPageMixins, siteMixins],
  name: 'collectInfo',
  props: {
    _dataId: [String, Number],
    btn_no: {
      type: Boolean,
      default: true
    },
  },
  components: {
    ShipmentsDialog

  },
  data() {
    return {
      showShipmentsDialog: false,

      parts_apply_add: false,
      parts_apply_edit: false,
      parts_apply_commit: false,
      parts_apply_audit: false,
      parts_apply_cancel: false,
      parts_apply_rejected: false,
      parts_apply_outbound: false,
      parts_apply_inbound: false,
      parts_apply_delivery: false,
      // parts_apply_stop: false,

      formData: {
        id: null,
        collectNo: null,  // 交货单号;自动生成:AC+年月日时分秒+4位随机数
        stat: 0,  // 状态:1待发货;3已发货;99取消;
        qty: 0,  // 交货数量
        collecterWorker: null,  // 交货人工号,对应sys_user.username
        collecter: null,  // 交货人名称,对应sys_user.name
        send1No: null,  // 外部交货单号
        send1Flag: 0,  // 交货同步状态：0未传;1失败;2已传
        send1Date: null,  // 交货同步时间
        send1Message: null,  // 交货同步备注
        send2No: null,  // 外部发货单号
        send2Flag: 0,  // 发货同步状态：0未传;1失败;2已传
        send2Date: null,  // 发货同步时间
        send2Message: null,  // 发货同步备注

        spPartsApplyCollectLineDTOList: []
      },

      isEdit: false,
      tabIndex: 'first',
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {

    this.parts_apply_add = this.permissions['parts_apply_add']
    this.parts_apply_edit = this.permissions['parts_apply_edit']
    this.parts_apply_commit = this.permissions['parts_apply_commit']
    this.parts_apply_audit = this.permissions['parts_apply_audit']
    this.parts_apply_cancel = this.permissions['parts_apply_cancel']
    this.parts_apply_rejected = this.permissions['parts_apply_rejected']
    this.parts_apply_outbound = this.permissions['parts_apply_outbound']
    this.parts_apply_inbound = this.permissions['parts_apply_inbound']
    this.parts_apply_delivery = this.permissions['parts_apply_delivery']

    this.dataId = this._dataId
  },
  mounted() {
    this.checkEnablePartsCollect()
    this.getData()
  },
  watch: {

  },
  methods: {
    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    checkEnablePartsCollect() {
      this.$http.post(api.spPartsApplyHeader.checkEnablePartsCollectUrl, {}).then(res => {
        this.enablePartsCollect = res.data.data
      })
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.$http.post(api.spPartsApplyCollectHeader.getDataUrl, {id: this.dataId}).then(response => {
          this.formData = response.data.data
        })
      }
    },

  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}

::v-deep .el-image {
  margin-right: 15px;
}
</style>
